export default __webpack_public_path__ + "static/media/side5.7d8112bd.svg";